import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Loja } from "../../../../services/Lojas";

export const useLojaHorariosDisponiveis = (
  uuidLoja: string,
  dataAgendamento: string,
) => {
  const query = useQuery({
    queryKey: ["loja-horarios-disponiveis", uuidLoja, dataAgendamento],
    queryFn: () => Loja.getHorariosDisponiveis({ uuidLoja, dataAgendamento }),
    select: (response) => response.data,
    enabled: !!uuidLoja && !!dataAgendamento,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
